import React, { useRef, useEffect, useState, useCallback } from 'react';

const Carousel = () => {
  const trackRef = useRef(null);
  const slideRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const updateCarousel = useCallback(() => {
    if (trackRef.current && slideRef.current) {
      const slideWidth = slideRef.current.clientWidth;
      trackRef.current.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
    }
  }, [currentIndex]);

  const nextSlide = () => {
    const totalSlides = trackRef.current?.children.length || 0;
    if (currentIndex < totalSlides - 1) {
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  useEffect(() => {
    updateCarousel();
  }, [updateCarousel]);

  useEffect(() => {
    window.addEventListener('resize', updateCarousel);
    return () => {
      window.removeEventListener('resize', updateCarousel);
    };
  }, [updateCarousel]);

  return (
    <section className="carousel-section">
      <h2 className="section-title">Nos Réalisations</h2>

      <div className="carousel-container">
        <button className="carousel-btn left" onClick={prevSlide}>
          &#10094;
        </button>

        <div className="carousel-track-wrapper">
          <div className="carousel-track" ref={trackRef}>
            <img
              src="/images/dashboard.PNG"
              className="carousel-slide"
              alt="Tableau de bord"
              ref={slideRef}
            />
            <img
              src="/images/statistics.PNG"
              className="carousel-slide"
              alt="Statistiques RH"
            />
          </div>
        </div>

        <button className="carousel-btn right" onClick={nextSlide}>
          &#10095;
        </button>
      </div>
    </section>
  );
};

export default Carousel;
